module.exports = __webpack_public_path__ + "media/images/icons/bold-ecbf2f1a3c39e47409494820b7931713.svg";